import { render, staticRenderFns } from "./CenterOffer.vue?vue&type=template&id=03d80662&scoped=true&"
import script from "./CenterOffer.vue?vue&type=script&lang=js&"
export * from "./CenterOffer.vue?vue&type=script&lang=js&"
import style0 from "./CenterOffer.vue?vue&type=style&index=0&id=03d80662&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d80662",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
